import { render, staticRenderFns } from "./ObjetivoIdoso.vue?vue&type=template&id=445bea74&scoped=true"
import script from "./ObjetivoIdoso.vue?vue&type=script&lang=js"
export * from "./ObjetivoIdoso.vue?vue&type=script&lang=js"
import style0 from "./ObjetivoIdoso.vue?vue&type=style&index=0&id=445bea74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445bea74",
  null
  
)

export default component.exports